import GradientButton from '../../components/GradientButton'

import type {
  LotStoryGroupShareShellView,
  TranslateFn
} from './lotStoryLibraryTypes'

type LotStoryGroupShareShellCardProps = {
  t: TranslateFn
  shareShell: LotStoryGroupShareShellView
  testIdPrefix: string
  onSaveTargetGroup: () => void
}

const getTestId = (prefix: string, suffix?: string) => suffix ? `${prefix}-${suffix}` : prefix

export default function LotStoryGroupShareShellCard({
  t,
  shareShell,
  testIdPrefix,
  onSaveTargetGroup
}: Readonly<LotStoryGroupShareShellCardProps>) {
  return (
    <div
      data-testid={getTestId(testIdPrefix)}
      style={{
        border: '1px solid #c7d2fe',
        borderRadius: 10,
        backgroundColor: '#eef2ff',
        padding: 12,
        display: 'grid',
        gap: 8
      }}
    >
      <div style={{ display: 'grid', gap: 4 }}>
        <strong style={{ fontSize: 12, color: '#4338ca' }}>{t('lots.story.groupShareShell.title')}</strong>
        <div style={{ fontSize: 13, color: '#4338ca' }}>{t('lots.story.groupShareShell.subtitle')}</div>
      </div>

      <div data-testid={getTestId(testIdPrefix, 'selected-target')} style={{ fontSize: 13, color: '#312e81' }}>
        <strong>{t('lots.story.groupShareShell.selectedTarget')}:</strong> {shareShell.selectedGroupLabel || t('lots.story.groupPreflight.none')}
      </div>

      <div data-testid={getTestId(testIdPrefix, 'saved-target')} style={{ fontSize: 13, color: '#312e81' }}>
        <strong>{t('lots.story.groupShareShell.savedTarget')}:</strong> {shareShell.savedGroupLabel || t('lots.story.groupShareShell.notSaved')}
      </div>

      {shareShell.errorMessage ? (
        <div data-testid={getTestId(testIdPrefix, 'status')} style={{ fontSize: 13, color: '#b91c1c', fontWeight: 700 }}>
          {shareShell.errorMessage}
        </div>
      ) : shareShell.statusMessage ? (
        <div data-testid={getTestId(testIdPrefix, 'status')} style={{ fontSize: 13, color: '#166534', fontWeight: 700 }}>
          {shareShell.statusMessage}
        </div>
      ) : null}

      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12, flexWrap: 'wrap' }}>
        <GradientButton
          type="button"
          onClick={onSaveTargetGroup}
          disabled={!shareShell.canSave || shareShell.saving}
          data-testid={getTestId(testIdPrefix, 'save-button')}
        >
          {shareShell.saving ? t('lots.story.groupShareShell.saving') : t('lots.story.groupShareShell.saveButton')}
        </GradientButton>
      </div>
    </div>
  )
}